import React, { useState } from 'react';
import { FaPhoneAlt, FaEnvelope, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isMenuOpen) setOpenDropdown(null);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenDropdown(null);
  };

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };
  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: 'about' },
    {
      name: 'Courses',
      subItems: [
        { name: 'FITTER', href: 'courses-fitter' },
        { name: 'ELECTRICIAN', href: 'courses-electrician' }
      ]
    },
    {
      name: 'Admission',
      subItems: [
        { name: 'Registration Form', href: '#registration' },
        { name: 'Prospectus', href: '#prospectus' },
        { name: 'Affiliation', href: '#affiliation' },
        { name: 'Committee', href: '#committee' }
      ]
    },
    { name: 'Placement', href: 'placement' },
    { name: 'Gallery', href: 'gallery' },
    { name: 'Contact', href: 'contact' }
  ];

  const socialLinks = [
    { icon: FaFacebookF, href: '#', label: 'Facebook' },
    { icon: FaTwitter, href: '#', label: 'Twitter' },
    { icon: FaInstagram, href: '#', label: 'Instagram' },
    { icon: FaLinkedinIn, href: '#', label: 'LinkedIn' }
  ];

  return (
    <>
      <div className="bg-gradient-to-r from-green-600 to-orange-500 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
          <div className="flex flex-col sm:flex-row justify-between items-center text-sm">
            <div className="flex flex-wrap justify-center gap-4 mb-2 sm:mb-0">
              <div className="flex items-center gap-1">
                <FaPhoneAlt className="h-3 w-3" />
                <span>+91 9956808612</span>
              </div>
              <div className="flex items-center gap-1">
                <FaPhoneAlt className="h-3 w-3" />
                <span>+91 8090586416</span>
              </div>
              <div className="flex items-center gap-1">
                <FaEnvelope className="h-3 w-3" />
                <a href="mailto:shardaiti2014@gmail.com" className="hover:underline">shardaiti2014@gmail.com</a>
              </div>
            </div>
            <div className="flex gap-3">
              {socialLinks.map((social, idx) => (
                <a
                  key={idx}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-80 transition-opacity"
                  aria-label={social.label}
                >
                  <social.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <nav className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center space-x-3">
              <img
                className="h-12 w-auto object-contain"
                src="/logo.png"
                alt="ITI Bhaupur Logo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://via.placeholder.com/48?text=ITI';
                }}
              />
              <div className="flex flex-col">
                <span className="text-xl font-bold bg-gradient-to-r from-blue-700 via-green-600 to-orange-500 bg-clip-text text-transparent">
                  ITI Bhaupur
                </span>
                <span className="text-xs text-gray-500 -mt-1">Jaunpur</span>
              </div>
            </div>
            <div className="hidden md:flex space-x-1 lg:space-x-2">
              {navLinks.map((link) => {
                if (link.subItems) {
                  return (
                    <div key={link.name} className="relative group">
                      <button
                        className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-orange-500 hover:bg-orange-50 transition-all duration-200 border-b-2 border-transparent hover:border-orange-500 flex items-center"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {link.name}
                        <svg
                          className="ml-1 w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-10">
                        <div className="py-1">
                          {link.subItems.map((sub) => (
                            <a
                              key={sub.name}
                              href={sub.href}
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-500"
                            >
                              {sub.name}
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <a
                      key={link.name}
                      href={link.href}
                      className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-orange-500 hover:bg-orange-50 transition-all duration-200 border-b-2 border-transparent hover:border-orange-500"
                    >
                      {link.name}
                    </a>
                  );
                }
              })}
            </div>
            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-orange-500 hover:bg-orange-50 focus:outline-none transition duration-200"
                aria-expanded={isMenuOpen}
              >
                <span className="sr-only">Open main menu</span>
                {!isMenuOpen ? (
                  <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                ) : (
                  <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
        <div className={`md:hidden transition-all duration-300 ease-in-out ${isMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
          <div className="px-2 pt-2 pb-3 space-y-1 bg-white shadow-lg border-t border-gray-100">
            {navLinks.map((link) => {
              if (link.subItems) {
                return (
                  <div key={link.name}>
                    <button
                      onClick={() => toggleDropdown(link.name)}
                      className="w-full flex justify-between items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-orange-500 hover:bg-orange-50 transition duration-200"
                    >
                      {link.name}
                      <svg
                        className={`w-4 h-4 transition-transform ${openDropdown === link.name ? 'rotate-180' : ''}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    <div className={`pl-4 space-y-1 ${openDropdown === link.name ? 'block' : 'hidden'}`}>
                      {link.subItems.map((sub) => (
                        <a
                          key={sub.name}
                          href={sub.href}
                          onClick={closeMenu}
                          className="block px-3 py-2 rounded-md text-sm text-gray-600 hover:text-orange-500 hover:bg-orange-50 transition duration-200"
                        >
                          {sub.name}
                        </a>
                      ))}
                    </div>
                  </div>
                );
              } else {
                return (
                  <a
                    key={link.name}
                    href={link.href}
                    onClick={closeMenu}
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-orange-500 hover:bg-orange-50 transition duration-200"
                  >
                    {link.name}
                  </a>
                );
              }
            })}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;